// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AwsNetwork } from './AwsNetwork';
import {
  AwsNetworkFromJSON,
  AwsNetworkFromJSONTyped,
  AwsNetworkToJSON,
  AwsNetworkToJSONTyped,
} from './AwsNetwork';
import type { AwsEks } from './AwsEks';
import {
  AwsEksFromJSON,
  AwsEksFromJSONTyped,
  AwsEksToJSON,
  AwsEksToJSONTyped,
} from './AwsEks';

/**
 *
 * @export
 * @interface AwsSpec
 */
export interface AwsSpec {
  /**
   *
   * @type {AwsEks}
   * @memberof AwsSpec
   */
  eks?: AwsEks;
  /**
   *
   * @type {AwsNetwork}
   * @memberof AwsSpec
   */
  network?: AwsNetwork;
}

/**
 * Check if a given object implements the AwsSpec interface.
 */
export function instanceOfAwsSpec(value: object): value is AwsSpec {
  return true;
}

export function AwsSpecFromJSON(json: any): AwsSpec {
  return AwsSpecFromJSONTyped(json, false);
}

export function AwsSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AwsSpec {
  if (json == null) {
    return json;
  }
  return {
    eks: json['eks'] == null ? undefined : AwsEksFromJSON(json['eks']),
    network:
      json['network'] == null ? undefined : AwsNetworkFromJSON(json['network']),
  };
}

export function AwsSpecToJSON(json: any): AwsSpec {
  return AwsSpecToJSONTyped(json, false);
}

export function AwsSpecToJSONTyped(
  value?: AwsSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    eks: AwsEksToJSON(value['eks']),
    network: AwsNetworkToJSON(value['network']),
  };
}
